export type ShiftPlannerSettings = {
    scheduling_tool_shift_color?: string;
};

const STORAGE_KEY = "shift_planner_settings";

export function getShiftPlannerSettings(): ShiftPlannerSettings {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? (parsed as ShiftPlannerSettings) : {};
    } catch {
        return {};
    }
}

export function setShiftPlannerSettings(patch: Partial<ShiftPlannerSettings>): ShiftPlannerSettings {
    const current = getShiftPlannerSettings();
    const next: ShiftPlannerSettings = { ...current, ...patch };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next;
}

export function getSchedulingToolShiftColor(defaultColor: string = "#744700"): string {
    const settings = getShiftPlannerSettings();
    return settings.scheduling_tool_shift_color || defaultColor;
}

export function setSchedulingToolShiftColor(color: string): void {
    if (!color) return;
    setShiftPlannerSettings({ scheduling_tool_shift_color: color });
}
